module.exports = __webpack_public_path__ + "img/index_list_item_icon_5.acaea122.svg";